import { useResendOTPMutation } from '@/redux/services/auth/authApi'
import routesPath from '@/utils/routesPath'
import { useState } from 'react'
import { toast } from 'sonner'
import AuthLayout from '../layout'

const { LOGIN } = routesPath

export default function OTPVerificationPage() {
  const [OTP, setOTP] = useState<any>('')

  const [resendOtp, { isLoading: loadingResendOtp }] = useResendOTPMutation()

  const handleResendOTP = async () => {
    try {
      const res = await resendOtp({}).unwrap()
      if (res.status) {
        toast.success(`${res.message}`)
      }
    } catch (error: any) {
      toast.error(`${error.message}`)
    }
  }

  return (
    <AuthLayout
      title='Enter Verification Code'
      subTitle='Enter the OTP Code send to ban****@gmail.com'
      hasBack
    >
      {/* <form>
        <div className='flex flex-col gap-3'>
          <InputOTPGenerator length={6} onChange={(code) => setOTP(code)} />
        </div>
        <span className='flex gap-1 items-center text-xs text-[#A3A3A3] justify-center text-center pt-3'>
          <span>Didn’t recieve code?</span>
          <Button
            variant={'link'}
            className='text-green-700'
            onClick={handleResendOTP}
          >
            Resend code
          </Button>
        </span>

        <div className='my-4 mt-10'>
          <Button disabled={loadingResendOtp}>Verify Code</Button>
          <span className='text-xs text-[#A3A3A3] block text-center pt-3'>
            Remember Password?
            <Link to={LOGIN} className='text-primary underline pl-1'>
              Login
            </Link>
          </span>
        </div>
      </form> */}
      <div></div>
    </AuthLayout>
  )
}
